import {useContext, useEffect} from 'react';
import {Outlet, useParams, Navigate} from 'react-router-dom';
import {NetworkContext} from '../lib/context';
import {networkOptimization} from '../../../lib/api';
import {safeConsoleError} from '../../../lib/sanitize';

type RosterIDParam = {
    rosterId: string
}

export function RosterIDWrapper() {
    const {rosterId} = useParams<RosterIDParam>();
    const networkOptimizationStore = useContext(NetworkContext);

    useEffect(() => {
        if (!rosterId)
            return;
        const abortController = new AbortController();

        networkOptimization.getUserProviderRoster(Number(rosterId), abortController.signal)
            .then((response) => {
                // Check if the request was aborted before setting state
                if (!abortController.signal.aborted) {
                    networkOptimizationStore.rosterFileName = response.find((roster: any) => roster.rosterId === (rosterId || '').toString())?.rosterName;
                    networkOptimizationStore.providerRosters = response;
                }
            })
            .catch((error) => {
                // Only log non-abort errors
                if (error.name !== 'AbortError' && !abortController.signal.aborted) {
                    safeConsoleError('Failed to fetch roster:', error);
                }
            });

        return () => {
            abortController.abort();
        };
    }, [rosterId]);

    // Check for existing streams when runId is set
    useEffect(() => {
        if (rosterId) {
            // Set the runId first
            networkOptimizationStore.runId = Number(rosterId);
            // Then check for existing streams to reconnect
            networkOptimizationStore.checkForExistingStreams();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rosterId]);

    if (!rosterId)
        return <Navigate to="/network-optimization/my-files" replace />;

    return <Outlet />;
}